import { render, staticRenderFns } from "./ModalMessageList.vue?vue&type=template&id=4f03589f&scoped=true"
import script from "./ModalMessageList.vue?vue&type=script&lang=js"
export * from "./ModalMessageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f03589f",
  null
  
)

export default component.exports